<script>
import { useAlert, useTrack } from 'dashboard/composables';
import MergeContact from 'dashboard/modules/contact/components/MergeContact.vue';

import ContactAPI from 'dashboard/api/contacts';

import { mapGetters } from 'vuex';
import { CONTACTS_EVENTS } from '../../helper/AnalyticsHelper/events';

export default {
  components: { MergeContact },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    primaryContact: {
      type: Object,
      required: true,
    },
  },
  emits: ['close', 'update:show'],
  data() {
    return {
      isSearching: false,
      searchResults: [],
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'contacts/getUIFlags',
    }),
    localShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
  },

  methods: {
    onClose() {
      this.$emit('close');
    },
    async onContactSearch(query) {
      this.isSearching = true;
      this.searchResults = [];

      try {
        const {
          data: { payload },
        } = await ContactAPI.search(query);
        this.searchResults = payload.filter(
          contact => contact.id !== this.primaryContact.id
        );
      } catch (error) {
        useAlert(this.$t('MERGE_CONTACTS.SEARCH.ERROR_MESSAGE'));
      } finally {
        this.isSearching = false;
      }
    },
    async onMergeContacts(parentContactId) {
      useTrack(CONTACTS_EVENTS.MERGED_CONTACTS);
      try {
        await this.$store.dispatch('contacts/merge', {
          childId: this.primaryContact.id,
          parentId: parentContactId,
        });
        useAlert(this.$t('MERGE_CONTACTS.FORM.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        useAlert(this.$t('MERGE_CONTACTS.FORM.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<template>
  <woot-modal
    v-model:show="localShow"
    :on-close="onClose"
    :close-on-backdrop="true"
    class="wlab-merge-contact-modal"
  >
    <div class="wlab-profile-shell flex flex-col">
      <div class="wlab-profile-shell__head">
        <button type="button" class="wlab-profile-shell__back" @click="onClose">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            width="16"
            height="16"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m15 18-6-6 6-6"
            />
          </svg>
          Back
        </button>
        <div class="wlab-profile-shell__title">
          {{ $t('MERGE_CONTACTS.TITLE') }}
        </div>
        <button
          type="button"
          class="wlab-profile-shell__close"
          aria-label="Close"
          @click="onClose"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            width="20"
            height="20"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m6 6 12 12m0-12L6 18"
            />
          </svg>
        </button>
      </div>
      <div class="wlab-profile-shell__body">
        <div class="wlab-profile-section">
          <p class="wlab-profile-muted">
            {{ $t('MERGE_CONTACTS.DESCRIPTION') }}
          </p>
          <div class="wlab-profile-card">
            <MergeContact
              :primary-contact="primaryContact"
              :is-searching="isSearching"
              :is-merging="uiFlags.isMerging"
              :search-results="searchResults"
              @search="onContactSearch"
              @cancel="onClose"
              @submit="onMergeContacts"
            />
          </div>
        </div>
      </div>
    </div>
  </woot-modal>
</template>
